export const apiUrl = `${process.env.REACT_APP_BASE_API_URL}/api/`;
export const stripeReturnUrl = 'https://burqup.com';
